import { memo, useEffect } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Typography, useMediaQuery } from '@mui/material';

// project imports
import menuItem from 'menu-items';
import NavGroup from './NavGroup';
import useConfig from 'hooks/useConfig';
import useAuth from 'hooks/useAuth'; // 追加

import LAYOUT_CONST from 'constant';
import { HORIZONTAL_MAX_ITEM } from 'config';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const theme = useTheme();
  const { layout } = useConfig();
  const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
  const { userProfile } = useAuth(); // 追加: ユーザー情報を取得

  const handlerMenuItem = () => {
    const isFound = menuItem.items.some((element) => {
      if (element.id === 'widget') {
        return true;
      }
      return false;
    });
  };

  // 修正: ユーザー種別と無料会員状態に基づいてfavoriteメニューを非表示にするかチェック
  const shouldHideFavorite = () => {
    const memberType = userProfile?.attributes?.member_flg;
    const subscriberStatus = userProfile?.attributes?.is_subscriber;

    // member_flgが9（非会員）、10（メルマガ会員）、0（個人会員）の場合
    const targetMemberTypes = ['9', '10', '0'];

    // is_subscriberが"0"（無料会員）または空文字の場合
    const isFreeUser = subscriberStatus === '0' || subscriberStatus === '' || !subscriberStatus;

    // 対象の会員種別かつ無料会員の場合に非表示
    return targetMemberTypes.includes(memberType) && isFreeUser;
  };

  // 追加: メニュー項目からfavoriteを除外する関数
  const filterMenuItems = (items) => {
    if (!shouldHideFavorite()) {
      return items; // 非表示の必要がない場合は元のメニューをそのまま返す
    }

    return items.map((item) => {
      if (item.children) {
        // children配列からfavoriteを除外
        const filteredChildren = item.children.filter((child) => child.id !== 'favorite');
        return {
          ...item,
          children: filteredChildren
        };
      }
      return item;
    });
  };

  useEffect(() => {
    handlerMenuItem();
    // eslint-disable-next-line
  }, []);

  // last menu-item to show in horizontal menu bar
  const lastItem = layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && !matchDownMd ? HORIZONTAL_MAX_ITEM : null;

  // 修正: フィルタリングされたメニューアイテムを使用
  const filteredMenuItems = filterMenuItems(menuItem.items);

  let lastItemIndex = filteredMenuItems.length - 1;
  let remItems = [];
  let lastItemId;

  if (lastItem && lastItem < filteredMenuItems.length) {
    lastItemId = filteredMenuItems[lastItem - 1].id;
    lastItemIndex = lastItem - 1;
    remItems = filteredMenuItems.slice(lastItem - 1, filteredMenuItems.length).map((item) => ({
      title: item.title,
      elements: item.children
    }));
  }

  // 修正: フィルタリングされたメニューアイテムを使用
  const navItems = filteredMenuItems.slice(0, lastItemIndex + 1).map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} lastItem={lastItem} remItems={remItems} lastItemId={lastItemId} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default memo(MenuList);
